module.exports = __webpack_public_path__ + "vrsafety/static/media/Speaker_Icon.001386aa.png";